import React from 'react';

const LanguagesContext = React.createContext();

export default LanguagesContext;
